module.exports = __webpack_public_path__ + "img/tianpengdeng.5ecfda4b.png";